import { render, staticRenderFns } from "./ActiveSessionsCard.vue?vue&type=template&id=61dc7da7&scoped=true"
import script from "./ActiveSessionsCard.vue?vue&type=script&lang=js"
export * from "./ActiveSessionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc7da7",
  null
  
)

export default component.exports